<!--
  This component was disigned to be used at inventory_report_check
-->
<template>
  <div class="" style="background: rgb(189, 214, 236); padding:15px 0px;">
    <div class="row" style="margin-bottom: 10px">
      <div class="col-xs-4" style="">
        <input-box-result
          v-for="f in formFields.col1" :key="f.name"
         :value="dataValues[f.name]" :label="f.label"/>
      </div>
      <div class="col-xs-4" style="">
        <input-box-result
          v-for="f in formFields.col2" :key="f.name"
          labelSize="L"
         :value="dataValues[f.name]" :label="f.label"/>

      </div>
      <div class="col-xs-4" style="">
        <input-box-result
          v-for="f in formFields.col3" :key="f.name"
         :value="dataValues[f.name]" :label="f.label"/>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { bus } from '@/libs/bus'
import debug from "debug";
var debug_search_control = debug("esma:report_totals_box");
import inputBoxResult from '@/components/fields/input-box-result';
export default {
  components: {
    "input-box-result":inputBoxResult
  },
  data() {
    return {
      data_values:{},
    };
  },
  computed: {
    dataValues:{
      get(){
        return this.data_values;
      },
      set(v){
        this.data_values = v;
      }
    },
    formFields() {
      return {
        col1:[
          {name:"reportable_team",label:"報告対象数"},
          {name:"number_of_reports",label:"報告数"},
          {name:"unreported_number",label:"未報告数"},
          {name:"report_rate",label:"報告率"},
        ],
        col2:[
          {name:"lack_of_license",label:"①ライセンス購入数の不足"},
          {name:"lost_license_certificate",label:"②ライセンス証書の紛失"},
          {name:"no_evidence_of_license_receipt",label:"③ライセンス証書の受領形跡無し"},
          {name:"other",label:"④その他"},
        ],
        col3:[
          {name:"number_of_items_to_be_linked",label:"紐付対象件数"},
          {name:"total_number_of_pegging",label:"総紐付数"},
          {name:"linking_rate",label:"紐付率"},
        ]
      }
    }
  },
  methods: {
    getVal(n){
      return this.dataValues[n] || 0;
    }
  },
  beforeMount() {},
  mounted() {
    bus.$on(this.$props.tag, (data)=>{
      this.dataValues = data;
    });


    // this.value2 = 0;
    // setInterval(()=>{
    //   this.value2 = this.value2 + 1;
    //   this.dataValues = {
    //     n3: this.value2
    //   };
    // },1000)

  },
  afterMount() {},
  beforeDestroy() {
    bus.$off(this.$props.tag);
  },
  props: {
    tag: { type: String, default: "reportTotalsBox" }
  },
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// report_totals_box.vue?292f4691